import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import authReducer from '../Auth/authReducer';
import userReducer from '../reducers/userReducer';
import dataGeneratorReducer from '../AppModules/Data/Reducers/dataGeneratorReducer';
import uploadReducer from '../AppModules/Data/Reducers/uploadReducer';
import datasetsReducer from '../AppModules/Data/Reducers/datasetsReducer';
import ganymedeReducer from '../AppModules/Ganymede/ganymedeReducer';
import titanReducer from '../AppModules/Titan/Reducers/titanReducer';

const reducers = combineReducers({
  authReducer,
  userReducer,
  dataGeneratorReducer,
  uploadReducer,
  datasetsReducer,
  ganymedeReducer,
  titanReducer,
});

export default createStore(reducers, composeWithDevTools(applyMiddleware(thunkMiddleware)));
